import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReservationPersonDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ReservationPersonApiClient extends BaseCRUDApiClient<ReservationPersonDtoModel> {
  baseUrl = this.config.apiEndpoint + '/reservation-person';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
